import { HfsActionEnum } from 'fleet-data-model';
import type { AssetListItem } from '~/data/AssetListItem/AssetListItem';
import type { ErrorType } from '~/data/ErrorRecord';
import type { InventoryV2MapSeed } from '~/domain/inventory-v2/models/inventory-v2';

export interface BatchCommandResultNotification {
  message: string;
  title: string;
  iconType: string;
  iconColor?: string;
  iprIds: string[];
  failedIprIds?: string[];
  hfsActionId?: HfsActionEnum;
}

export const defaultState: Fields = {
  isLoading: false,
  showIsLoading: true,
  forceReload: false,
  scrollToSelected: false,
  openUnmountSensorWarning: false,
  selectedAll: false,
  assets: [],
  totalNumberOfAssets: 0,
  selectedAssetIds: [],
  highlightedAssetIds: [],
  batchCommandsResultsNotifications: [],
  error: undefined,
  dashboardMapClusterSelected: null,
};

export interface Fields {
  selectedAll: boolean;
  isLoading: boolean;
  showIsLoading: boolean;
  forceReload: boolean;
  openUnmountSensorWarning: boolean;
  scrollToSelected: boolean;
  assets: AssetListItem[];
  highlightedAssetIds: AssetId[];
  totalNumberOfAssets: number;
  selectedAssetIds: AssetId[];
  error?: ErrorType;
  dashboardMapClusterSelected?: DashboardMapClusterSelected | null;
  batchCommandsResultsNotifications: BatchCommandResultNotification[];
  batchCommandsSelectionIndication?: boolean;
}

export interface DashboardMapClusterSelected {
  assetIds: AssetId[];
  zoomLevel: number;
  scrollTo: boolean;
  clusterId?: number;
}

/** Router state the dashboard map passes to `/inventory` when it hands over a cluster. */
export interface DashboardMapClusterState extends DashboardMapClusterSelected {
  /** The cluster's assets as the map holds them, so the paged list can show them before loading. */
  seeds?: InventoryV2MapSeed[];
}
